module.exports = __webpack_public_path__ + "static/img/coupon_bg_en_invalid.c4b821dc.png";